import cn from 'classnames';
import * as React from 'react';

import { useSpacingCtx } from '../context';

import s from './SpacingRowBase.module.scss';

export type SpacingRowBaseProps = React.HTMLProps<HTMLDivElement> & {
  verticalGrow?: boolean;
};

const SpacingRowBase: React.FC<SpacingRowBaseProps> = ({
  verticalGrow,
  className,
  ...props
}: SpacingRowBaseProps) => {
  const { betweenRows } = useSpacingCtx();

  return (
    <div
      className={cn(
        className,
        s['spacing-row-base'],
        verticalGrow && s['spacing-row-base_vertical-grow'],
        s[`spacing-row-base_between-rows-${betweenRows}`]
      )}
      {...props}
    />
  );
};

SpacingRowBase.displayName = 'Spacing.RowBase';

export default SpacingRowBase;
